import {
    faBars,
    faCircleQuestion,
    faClipboardList,
    faHeart,
    faHouse,
    faStar,
    faUser,
    faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const CustomBurgerIcon = (
    <span>
        <FontAwesomeIcon icon={faBars} /> Меню
    </span>
);

export const CustomCloseIcon = <FontAwesomeIcon icon={faXmark} />;

export const HomeIcon = <FontAwesomeIcon icon={faHouse} />;
export const MyNumbersIcon = <FontAwesomeIcon icon={faClipboardList} />;
export const DrugomaniyaIcon = <FontAwesomeIcon icon={faStar} />;
export const BookedIcon = <FontAwesomeIcon icon={faHeart} />;
export const ProfileIcon = <FontAwesomeIcon icon={faUser} />;
export const HelpIcon = <FontAwesomeIcon icon={faCircleQuestion} />;

export const TelegramIcon = <img src="/images/icons/media/telegram.svg" alt="" />;
export const VKIcon = <img src="/images/icons/media/vk.svg" alt="" />;
